import { Protocols } from '../../../../types/policies';
import { POLICY_ACTION_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { FieldName, PolicyFormValues } from '../types/forms';

const isServersFieldRelevant = (formValues: PolicyFormValues): boolean => {
    return formValues.protocol === Protocols.KERBEROS_NTLM || formValues.protocol === Protocols.KERBEROS || formValues.protocol === Protocols.NTLM;
};

const isMfaPolicy = (formValues: PolicyFormValues): boolean => {
    return formValues.action_type === POLICY_ACTION_TYPES.MFA.value;
};

const isBridgePolicy = (formValues: PolicyFormValues): boolean => {
    return formValues.action_type === POLICY_ACTION_TYPES.BRIDGE.value;
};

const isMfaOrBridgePolicy = (formValues: PolicyFormValues): boolean => {
    return isMfaPolicy(formValues) || isBridgePolicy(formValues);
};

const isServersIpRelevant = (formValues: PolicyFormValues): boolean => {
    return formValues.protocol === Protocols.LDAP;
};

export const POLICY_FIELDS_FORM_RELEVANCE_VALIDATORS: {
    [key in FieldName]?: (formValues: PolicyFormValues) => boolean;
} = {
    servers: isServersFieldRelevant,
    servers_ips: isServersIpRelevant,
    allowed_token_types: isMfaPolicy,
    display_name: isMfaOrBridgePolicy
};

export const DC_IN_DESTINATION_ERROR_MESSAGE =
    'This policy cannot be enforced for this protocol, with a DC as Destination.';

export const ACTION_DISCLAIMER_BASE =
    'Silverfort recommends starting with Notify as an action, allowing Silverfort to log the requests in the Authentication Logs. After one week, review the policy logs using a custom report to validate the target audience, frequency, and more. Once you’ve evaluated the policy’s behavior, consider changing the action to'

export const ACTION_DISCLAIMER = `${ACTION_DISCLAIMER_BASE} MFA.`;

export const APPLICATION_TEMPLATE_PROTOCOL_TOOLTIP =
    'If selecting Kerberos/NTLM, ensure the relevant SPNs and correct destinations are included.';
